import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
    OutletListingItem,
    OutletReduxState,
} from './types';

const initialState: OutletReduxState = {
    loadings: {
        getOutletListing: false,
    },
    getOutletListing: [],
    errors: {
        getOutletListing: '',
    },
};

const outletSlice = createSlice({
    name: 'outlet',
    initialState,
    reducers: {
        outletGetOutletListingAttempt: (state) => {
            state.loadings.getOutletListing = true;
            state.errors.getOutletListing = '';
        },
        outletGetOutletListingSuccess: (state, action: PayloadAction<OutletListingItem[]>) => {
            state.loadings.getOutletListing = false;
            state.getOutletListing = action.payload;
        },
        outletGetOutletListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getOutletListing = false;
            if (action.payload) state.errors.getOutletListing = action.payload;
        },
    },
});

export type OutletState = typeof initialState;

export default {
    actions: outletSlice.actions,
    reducers: outletSlice.reducer,
};
